import React, { useState } from "react";
import { useNotaire } from "../../context/NotaireContext";
import { Input } from "../../components/catalyst/input";
import { Field, Label } from "../../components/catalyst/fieldset";
import { toast } from "react-toastify";

function PanelNotaireInfo() {
  const context = useNotaire();
  const [form, setForm] = useState({
    nom: context.user.nom || "",
    prenom: context.user.prenom || "",
    telephone: context.infoEtude.telephone || "",
    site: context.infoEtude.site || "",
    linkedin: context.infoNotaire.linkedin || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // PATCH 1: table "user"
      const userRes = await fetch(`https://api.airtable.com/v0/appD48APNaGA4GN0B/user/${context.user.airtable_id}`, {
        method: "PATCH",
        headers: {
          Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
                        Accept: "application/json",
                        "Content-Type": "application/json",
        },
        body: JSON.stringify({ fields: { nom: form.nom, prenom: form.prenom } }),
      });

      // PATCH 2: table "etudes"
      const etudeRes = await fetch(`https://api.airtable.com/v0/appD48APNaGA4GN0B/etudes/${context.infoEtude.id}`, {
        method: "PATCH",
        headers: {
          Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
                        Accept: "application/json",
                        "Content-Type": "application/json",
        },
        body: JSON.stringify({ fields: { telephone: form.telephone, site: form.site } }),
      });

      // PATCH 3: table "info-notaire"
      const infoRes = await fetch(`https://api.airtable.com/v0/appD48APNaGA4GN0B/info-notaire/${context.infoNotaire.id}`, {
        method: "PATCH",
        headers: {
          Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
                        Accept: "application/json",
                        "Content-Type": "application/json",
        },
        body: JSON.stringify({ fields: { linkedin: form.linkedin } }),
      });

      if (userRes.ok && etudeRes.ok && infoRes.ok) {
        toast.success("Informations mises à jour !");
      } else {
        toast.error("Erreur lors de la mise à jour.");
        console.warn("❌ Détails:", await userRes.text(), await etudeRes.text(), await infoRes.text());
      }
    } catch (err) {
      console.error("Erreur réseau:", err);
      toast.error("❌ Erreur réseau");
    }
  };

  return (
    <div className=" bg-white p-6 rounded shadow">
      <form onSubmit={handleSubmit} className="space-y-4">

        <Field>
          <Label>Nom</Label>
          <Input name="nom" value={form.nom} onChange={handleChange} />
        </Field>

        <Field>
          <Label>Prénom</Label>
          <Input name="prenom" value={form.prenom} onChange={handleChange} />
        </Field>

        <Field>
          <Label>Téléphone</Label>
          <Input name="telephone" value={form.telephone} onChange={handleChange} />
        </Field>

        <Field>
          <Label>Site internet</Label>
          <Input name="site" value={form.site} onChange={handleChange} />
        </Field>

        <Field>
          <Label>LinkedIn</Label>
          <Input name="linkedin" value={form.linkedin} onChange={handleChange} />
        </Field>

        <button type="submit" className="btn-primary mt-4">
          Modifier
        </button>
      </form>
    </div>
  );
}

export default PanelNotaireInfo;